/*
 * @Author: 陈红伟 chenhw2019@gmail.com
 * @Date: 2024-01-17 15:57:56
 * @LastEditors: Chenhw2017 1272617071@qq.com
 * @LastEditTime: 2024-06-12 14:55:26
 * @FilePath: /seller.sviptrader.com/src/views/configure/message/columns.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import ColumnTypes from '@/utils/ColumnTypes';

const message_name = {
	label: '消息名称',
	type: () => import('./tableCells/messgaeName.vue'),
	minWidth: '200',
};

const message_desc = {
	key: 'message_desc',
	label: '简介',
	type: 'rdText',
	minWidth: '277',
	ellipsisRow: 2,
};

const send_type = {
	key: 'send_type',
	label: '推送方式',
	type: 'rdText',
	width: '210',
	ellipsisRow: 2,
};

const receivers = {
	key: 'receivers',
	label: '接收者',
	type: 'rdText',
	width: '220',
	ellipsisRow: 1,
};

const open = {
	label: '开启状态',
	type: () => import('./tableCells/cooSwitchCell.vue'),
	width: '150',
};

const operations = {
	key: 'operations',
	label: '操作',
	type: ColumnTypes.ButtonsCell,
	width: '150',
	align: 'right',
	bigger: false,
	showMax: 4,
};

export const columns = [message_name, message_desc, send_type, receivers, open, operations];
